import toast from "react-hot-toast";
import { CUSTOMER_ORDER_DETAIL, CUSTOMER_ORDER_DETAIL_FAIL, CUSTOMER_ORDER_DETAIL_SUCCESS, CUSTOMER_ORDER_LIST, CUSTOMER_ORDER_LIST_FAIL, CUSTOMER_ORDER_LIST_SUCCESS, CUSTOMER_ORDER_UPDATE, CUSTOMER_ORDER_UPDATE_FAIL, CUSTOMER_ORDER_UPDATE_SUCCESS, ORDER_CREATE, ORDER_CREATE_FAIL, ORDER_CREATE_SUCCESS, PERSONAL_SHOPPER_ASSIGN, PERSONAL_SHOPPER_ASSIGN_FAIL, PERSONAL_SHOPPER_ASSIGN_SUCCESS, PERSONAL_SHOPPER_LIST, PERSONAL_SHOPPER_LIST_FAIL, PERSONAL_SHOPPER_LIST_SUCCESS, CREATE_PAYMENT_ORDER, CREATE_PAYMENT_ORDER_SUCCESS, CREATE_PAYMENT_ORDER_FAIL, VERIFY_PAYMENT, VERIFY_PAYMENT_SUCCESS, VERIFY_PAYMENT_FAIL, GET_PAYMENTS, GET_PAYMENTS_SUCCESS, GET_PAYMENTS_FAIL, RETRY_PAYMENT, RETRY_PAYMENT_SUCCESS, RETRY_PAYMENT_FAIL } from "../actions/OrderAction";

function parseCustomerOrderListPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.recordList)) return payload.recordList;
  return [];
}

function parseCustomerOrderDetailPayload(payload) {
  if (!payload) return null;
  const candidate = payload.data ?? payload;
  if (
    candidate?.id != null &&
    typeof candidate === "object" &&
    !Array.isArray(candidate)
  ) {
    return candidate;
  }
  if (candidate?.data?.id != null) return candidate.data;
  return null;
}

const initialState = {
  isLoading: false,
  /** Customer order table (`CUSTOMER_ORDER_LIST`) — avoids mixing with `ORDER_CREATE` / shopper `isLoading`. */
  isCustomerOrderListLoading: false,
  hasFetchedCustomerOrderList: false,
  isMeLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
  totalPages: 0,
  total: 0,
  recordList: [],
  persoalShopper: [],
  orderDetail: null,
  orderDetailLoading: false,
  orderDetailError: null,
  orderPayments: null,
  orderPaymentsLoading: false,
  orderPaymentsError: null,
};
const orderReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ORDER_CREATE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ORDER_CREATE_SUCCESS: {
      toast.success(payload?.message);
      return {
        ...state,
        isLoading: false,
      };
    }
    case ORDER_CREATE_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error.data.message,
      };
    }

    case CUSTOMER_ORDER_LIST: {
      return {
        ...state,
        isLoading: true,
        isCustomerOrderListLoading: true,
      };
    }
    case CUSTOMER_ORDER_LIST_SUCCESS: {
      const list = parseCustomerOrderListPayload(payload);
      const meta =
        payload?.data && !Array.isArray(payload.data) ? payload.data : payload;
      return {
        ...state,
        recordList: list,
        orderSummary: meta?.orderSummary ?? payload?.orderSummary,
        total: meta?.total ?? payload?.total ?? list.length,
        totalPages: meta?.totalPages ?? payload?.totalPages,
        isLoading: false,
        isCustomerOrderListLoading: false,
        hasFetchedCustomerOrderList: true,
      };
    }
    case CUSTOMER_ORDER_LIST_FAIL: {
      return {
        ...state,
        isLoading: false,
        isCustomerOrderListLoading: false,
        hasFetchedCustomerOrderList: true,
        isSuccess: false,
        isError: true,
        message: payload?.error.data.message,
      };
    }

    case CUSTOMER_ORDER_DETAIL: {
      return {
        ...state,
        orderDetailLoading: true,
        orderDetailError: null,
      };
    }
    case CUSTOMER_ORDER_DETAIL_SUCCESS: {
      return {
        ...state,
        orderDetail: parseCustomerOrderDetailPayload(payload),
        orderDetailLoading: false,
        orderDetailError: null,
      };
    }
    case CUSTOMER_ORDER_DETAIL_FAIL: {
      toast.error(payload?.error?.data?.message || "Could not load order");
      return {
        ...state,
        orderDetailLoading: false,
        orderDetailError: payload?.error?.data?.message || "Error",
        orderDetail: null,
      };
    }

    case CUSTOMER_ORDER_UPDATE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CUSTOMER_ORDER_UPDATE_SUCCESS: {
      toast.success(payload?.message || "Order updated");
      return {
        ...state,
        isLoading: false,
      };
    }
    case CUSTOMER_ORDER_UPDATE_FAIL: {
      toast.error(payload?.error?.data?.message || "Update failed");
      return {
        ...state,
        isLoading: false,
      };
    }

    case PERSONAL_SHOPPER_LIST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case PERSONAL_SHOPPER_LIST_SUCCESS: {
      return {
        ...state,
        persoalShopper: payload.data,
        total: payload.data.total,
        totalPages: payload.data.totalPages,
        isLoading: false,
      };
    }
    case PERSONAL_SHOPPER_LIST_FAIL: {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error.data.message,
      };
    }

    case PERSONAL_SHOPPER_ASSIGN: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case PERSONAL_SHOPPER_ASSIGN_SUCCESS: {
      toast.success(payload?.message || "Shopper assigned successfully");
      return {
        ...state,
        persoalShopper: payload.data.data,
        total: payload.data.total,
        totalPages: payload.data.totalPages,
        isLoading: false,
      };
    }
    case PERSONAL_SHOPPER_ASSIGN_FAIL: {
      toast.error(payload?.error?.data?.message || "Failed to assign shopper");
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error.data.message,
      };
    }

    case CREATE_PAYMENT_ORDER:
    case VERIFY_PAYMENT:
    case RETRY_PAYMENT: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case CREATE_PAYMENT_ORDER_SUCCESS:
    case VERIFY_PAYMENT_SUCCESS:
    case RETRY_PAYMENT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case CREATE_PAYMENT_ORDER_FAIL:
    case VERIFY_PAYMENT_FAIL:
    case RETRY_PAYMENT_FAIL: {
      return {
        ...state,
        isLoading: false,
        isError: true,
        message: payload?.error?.data?.message || payload?.error?.message || "Payment operation failed",
      };
    }

    case GET_PAYMENTS: {
      return {
        ...state,
        orderPaymentsLoading: true,
        orderPaymentsError: null,
      };
    }

    case GET_PAYMENTS_SUCCESS: {
      return {
        ...state,
        orderPaymentsLoading: false,
        orderPayments: payload.data ?? payload,
      };
    }

    case GET_PAYMENTS_FAIL: {
      return {
        ...state,
        orderPaymentsLoading: false,
        orderPaymentsError: payload?.error?.data?.message || payload?.error?.message || "Failed to fetch payments",
      };
    }

    default: {
      return { ...state };
    }
  }
};
export default orderReducer;
